import React from 'react';
import { useIsFetching } from '@tanstack/react-query';
import styled from 'styled-components';

// Stile per l'overlay del loader
const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2); /* Sfondo semitrasparente */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: none; /* Non blocca l'interazione con il contenuto sottostante */
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: opacity 0.3s ease, visibility 0.3s ease;

  /* Aggiungi altezza minima per il contenuto del loader */
  min-height: 300px; /* Altezza minima garantita */

  video {
    display: block;
    width: 300px; /* Regola la dimensione del video */
    height: auto;
    border-radius: 8px; /* Opzionale: bordi arrotondati */
    pointer-events: none;
  }
`;

const GlobalLoader = ({ children }) => {
  const isFetching = useIsFetching(); // Numero di query in corso
  const videoPath = "https://rossomotori.it/videos/loader.mp4";

  return (
    <>
      <LoaderOverlay isVisible={isFetching > 0}>
        <video autoPlay loop muted playsInline>
          <source src={videoPath} type="video/mp4" />
          Il tuo browser non supporta i video HTML5.
        </video>
      </LoaderOverlay>
      {children}
    </>
  );
};

export default GlobalLoader;
